import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { CircularProgress, Grid, Tooltip } from "@mui/material";
import { useMutation, useQuery, useQueryClient } from "react-query";
import {
  Backdrop,
  Box,
  Button,
  FormControl,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { useHistory, withRouter } from "react-router-dom";
import { createTheme } from "@mui/material/styles";
import rtlPlugin from "stylis-plugin-rtl";
import { prefixer } from "stylis";
import createCache from "@emotion/cache";
import useCollapse from "react-collapsed";
import { useEffect, useState } from "react";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import MoreHorizIcon from "@mui/icons-material/MoreHoriz";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import { connect, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { createStyles, Theme, makeStyles } from "@material-ui/core";
import {
  ApiResultModel,
  ColumnModel,
  PageInfoModel,
} from "../../models/common.model";
import { FilterRegister } from "../../models/loan.model";
import {
  GetPaymentSettlementResponse,
  GetSettlementRequestsBySupplierRequest,
  GetSettlementRequestsBySupplierResponse,
} from "../../models/supplierPayment.model";
import {
  GetPaymentSettlements,
  GetSettlementRequestsBySupplier,
} from "../../services/supplierPayment.service";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import ModalSettlementType from "../../components/modals/ModalSettlementType";

const useStyles = makeStyles((theme) =>
  createStyles({
    select: {
      "&.Mui-selected": {
        backgroundColor: muiSelected,
      },
    },
  })
);

const nextIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Next.png" />
  );
};
const previusIcon = () => {
  return (
    <img style={{ height: "12px", width: "10px" }} src="images/Previous.png" />
  );
};

const theme = createTheme({
  direction: "rtl", // Both here and <body dir="rtl">
});
// Create rtl cache
const cacheRtl = createCache({
  key: "muirtl",
  stylisPlugins: [prefixer, rtlPlugin],
});

const columns: readonly ColumnModel[] = [
  { id: "supplier", label: "نام پذیرنده" },
  { id: "supplierUser", label: "کاربر پذیرنده" },
  {
    id: "requestDate_Persian",
    label: "تاریخ درخواست",
  },
  {
    id: "settlementAmount",
    label: "مبلغ تسویه (ریال)",
    hasFormat: true,
    format: (value: number) => {
      return value.toLocaleString("fa");
    },
  },
  {
    id: "supplierIban",
    label: "شماره شبا پذیرنده",
  },
  {
    id: "description",
    label: "توضیحات",
  },
];
let muiSelected: any;

function SettlementRequestsBySupplier({
  stateCartable,
  status,
}: TableCmpPropsInterface) {
  let row: any;
  const jsonFile = useSelector((state: any) => state.style);

  muiSelected = jsonFile?.muiSelected;
  const classes = useStyles();
  const activePage = localStorage.getItem("setActivePage");
  const queryClient = useQueryClient();
  // queryClient.setQueryData(WORK_FLOW_TYPE, undefined);
  // const history = useHistory();
  const history = useHistory<{
    from: string;
    id: string;
    pageNumber: number;
    clickOnBack: boolean;
  }>();

  const [isExpanded, setExpanded] = useState(false);
  const [valueMultiSelect, setValueMultiSelect] = useState<string[]>([]);
  const [
    supplierSettlementRequestKeys,
    setSupplierSettlementRequestKeys,
  ] = useState<string[]>([]);
  const [
    valueSupplierSettlementStatus,
    setValueSupplierSettlementStatus,
  ] = useState<string[]>([]);
  const [valueLoanRequestSources, setValueLoanRequestSources] = useState([]);
  const [valueLoanTemplateOptions, setValueLoanTemplateOptions] = useState<
    string[]
  >([]);
  const [valueLoanTemplate, setValueLoanTemplate] = useState<any[]>([]);
  const [valueSupplierUserOptions, setValueSupplierUserOptions] = useState([]);
  const [valueCustomerFullName, setValueCustomerFullName] = React.useState<
    string
  >();
  const [
    valueCustomerNationalCode,
    setValueCustomerNationalCode,
  ] = React.useState<string>();
  const [
    valueCustomerMobileNumber,
    setValueCustomerMobileNumber,
  ] = React.useState<string>();
  const [valueRequestDate, setValueRequestDate] = React.useState<string>();
  const [valueFilterData, setValueFilterData] = React.useState<
    FilterRegister
  >();
  const [valueStatusDate, setValueStatusDate] = React.useState<string>();

  const { getCollapseProps, getToggleProps } = useCollapse({
    isExpanded,
    collapsedHeight: 0,
  });
  const [data, setData] = React.useState<
    GetSettlementRequestsBySupplierResponse[]
  >([]);
  const [allData, setAllData] = React.useState<
    GetSettlementRequestsBySupplierResponse[]
  >([]);
  const [playlistData, setPlaylistData] = React.useState<
    GetSettlementRequestsBySupplierResponse[]
  >([]);
  const [settlementAmount, setSettlementAmount] = React.useState<number>(0);
  const [openVerifyModal, setOpenVerifyModal] = React.useState(false);
  const [openCancelModal, setOpenCancelModal] = React.useState(false);
  const [sendConfirmation, setSendConfirmation] = React.useState(false);

  const onClickSettlementType = () => {
    setOpenVerifyModal(true);
  };

  function addAllData() {
    setPlaylistData(allData);
    window.sessionStorage.setItem("playlistData", JSON.stringify(allData));
    setData([]);

    data.map((item: any) => {
      setSettlementAmount((prev: any) => prev + item.settlementAmount);
      let keys: any = supplierSettlementRequestKeys;
      keys.push(item.key);
      setSupplierSettlementRequestKeys(keys);
    });
  }

  function removeAllData() {
    window.sessionStorage.setItem("playlistData", "");
    setPlaylistData([]);
    setData(allData);
    setSettlementAmount(0);
    setSupplierSettlementRequestKeys([]);
  }
  function addInPlayList(value: any) {
    let listData: any = playlistData;
    listData.push(value);
    setPlaylistData(listData);
    window.sessionStorage.setItem("playlistData", JSON.stringify(listData));
    let filter = data.filter((item: any) => item.key != value.key);
    setData(filter);
    let amount = settlementAmount
      ? settlementAmount + value.settlementAmount
      : value.settlementAmount;
    setSettlementAmount(amount);
    let keys: any = supplierSettlementRequestKeys;
    keys.push(value.key);
    setSupplierSettlementRequestKeys(keys);
  }

  function removeFromPlayList(value: any) {
    let add = data;
    add.push(value);
    setData(add);
    let filter = playlistData.filter((item: any) => item.key != value.key);
    setPlaylistData(filter);
    window.sessionStorage.setItem("playlistData", JSON.stringify(filter));
    let amount = settlementAmount
      ? settlementAmount - value.settlementAmount
      : value.settlementAmount;
    setSettlementAmount(amount);
    let keys = supplierSettlementRequestKeys.filter(
      (item: any) => item != value.key
    );
    setSupplierSettlementRequestKeys(keys);
  }
  // const [pageInfo, setPageInfo] = React.useState<PageInfoModel>(
  //   (): PageInfoModel => {
  //     let pageInfoModel = new PageInfoModel();
  //     pageInfoModel.pageNumber = -1;
  //     pageInfoModel.pageSize = 10;
  //     pageInfoModel.total = 0;

  //     return pageInfoModel;
  //   }
  // );
  // const [currentPaginationInfo, setCurrentPaginationInfo] = React.useState(
  //   (): PaginationInfo => {
  //     let paginationInfo = new PaginationInfo();
  //     paginationInfo.pageNumber = 1;
  //     return paginationInfo;
  //   }
  // );
  // const [loanRequestStatus, setLoanRequestStatus] = React.useState<
  //   GetStatusResponse[]
  // >([]);
  // const [loanRequestOptions, setLoanRequestOptions] = React.useState<
  //   GetStatusResponse[]
  // >([]);
  // const [loanTemplateOptions, setLoanTemplateOptions] = React.useState<
  //   GetStatusResponse[]
  // >([]);
  const [requestDate, setRequestDate] = React.useState<
    Date[] | null | undefined
  >(null);
  const [statusDate, setStatusDate] = React.useState<Date[] | null | undefined>(
    null
  );
  const [selectedRow, setSelectedRow] = useState(undefined);

  // const previousPage =
  //   history.location.state !== undefined ? history.location.state.from : null;
  // useQuery<GetStatusResponse[]>(LOAN_TEMPLATE_APP, GetLoanTemplatesForApp, {
  //   onSuccess(data) {
  //     setLoanTemplateOptions(data);
  //   },
  // });
  // useQuery<GetStatusResponse[]>(
  //   LOAN_REQUEST_STATUS_APP,
  //   GetRegistrationStatus,
  //   {
  //     onSuccess(data) {
  //       setLoanRequestStatus(data);
  //     },
  //   }
  // );
  React.useEffect(() => {
    let SupplierResponse = new GetSettlementRequestsBySupplierRequest();
    getSettlementRequestsBySupplierMutation.mutate(SupplierResponse);

    // if (history.action === "POP" && oldPage?.rowNumber != undefined) {
    //   row = queryClient.getQueryData(TABLE_FILTER_APP_ROWNumber);
    //   setSelectedRow(row?.rowNumber);
    // }
    // if (
    //   (history.action === "PUSH" || history.action === "REPLACE") &&
    //   oldPage?.rowNumber == undefined
    // ) {
    //   row = undefined;
    //   setSelectedRow(row);
    // }
    // if (history.action === "POP" && oldPage?.rowNumber == undefined) {
    //   row = undefined;
    //   setSelectedRow(row);
    // }
    // if (
    //   (history.action === "PUSH" || history.action === "REPLACE") &&
    //   oldPage?.rowNumber != undefined
    // ) {
    //   row = queryClient.getQueryData(TABLE_FILTER_APP_ROWNumber);
    //   setSelectedRow(row?.rowNumber);
    // }

    // let filterData;
    // if (
    //   previousPage !== null ||
    //   (history.action === "REPLACE" &&
    //     history.location.state !== undefined &&
    //     history.location.state.clickOnBack)
    // ) {
    //   filterData = queryClient.getQueryData<FilterRegister>(TABLE_FILTER_APP);
    //   if (filterData !== undefined && filterData !== null) {
    //     setValueMultiSelect(filterData!.loanRequestStatus!);
    //     setValueLoanTemplateOptions(filterData?.loanTemplateIds!);
    //     setValueLoanTemplate(filterData!.valueLoanTemplate!);
    //     setValueCustomerFullName(filterData?.customerFullName!);
    //     setValueCustomerNationalCode(filterData?.customerNationalCode!);
    //     setValueCustomerMobileNumber(filterData?.customerMobileNumber!);
    //     setValueRequestDate(filterData?.requestDatePersian!);
    //     setValueStatusDate(filterData?.statusDatePersian!);
    //     setRequestDate(filterData?.requestDateArray!);
    //     setStatusDate(filterData?.statusDateArray!);
    //   }
    // } else {
    //   // filter.state = stateCartable.stateCartable;
    //   filterData = new FilterRegister();
    //   filterData.customerFullName = "";
    //   filterData.customerNationalCode = "";
    //   filterData.customerMobileNumber = "";
    //   filterData.loanTemplateIds = [];
    //   filterData.loanRequestStatus = [];
    //   filterData.requestDateArray = [];
    //   filterData.requestDatePersian = "";
    //   filterData.statusDateArray = [];
    //   filterData.statusDatePersian = "";
    //   queryClient.setQueryData(TABLE_FILTER_APP, null);
    // }
    // fillData(filterData!);
    // const filterApp = new FilterFinder();
    // filterApp.state = stateCartable.stateCartable;
    // queryClient.setQueryData(TABLE_FILTER_APP_ROWNumber, filterApp);
  }, []);
  let playListarray = [] as any;
  const getSettlementRequestsBySupplierMutation = useMutation(
    GetSettlementRequestsBySupplier,
    {
      onSuccess: (result: GetSettlementRequestsBySupplierResponse[]) => {
        if (result) {
          let getPlayList = window.sessionStorage.getItem("playlistData");
          if (
            getPlayList !== "" &&
            getPlayList !== null &&
            getPlayList !== undefined
          ) {
            playListarray = JSON.parse(getPlayList ? getPlayList : "");
            setPlaylistData(playListarray);
          }
          if (playListarray.length > 0) {
            const finalPlayList = result.filter((col) => {
              return playListarray.every(
                (selected: any) => selected.key !== col.key
              );
            });
            setData(finalPlayList);
          } else {
            setData(result);
          }
        } else {
          setData(result);
        }
        setAllData(result);
      },
    }
  );
  // const getSettlementRequestsBySupplierMutation = useMutation(GetSettlementRequestsBySupplier, {
  //   onSuccess: (result: GetSettlementRequestsBySupplierResponse[]) => {
  //     if (result) {
  //       setData(result);
  //     }
  //   },
  // });

  // const ExportLoanRegisterRequestsMutation = useMutation(
  //   exportLoanRegisterRequests,
  //   {
  //     onSuccess: (result) => { },
  //     onError: (e) => { },
  //   }
  // );

  // const setChildValueStat = (childValues: any) => {
  //   const selectedItem = valueMultiSelect.filter(
  //     (item: any) => item != childValues
  //   );
  //   setValueMultiSelect(selectedItem);
  //   const tabelFilter = queryClient.getQueryData<FilterRegister>(
  //     TABLE_FILTER_APP
  //   );
  //   if (tabelFilter != undefined && tabelFilter != null) {
  //     tabelFilter!.loanRequestStatus = tabelFilter!.loanRequestStatus
  //       ?.filter((item: any) => item != childValues)
  //       .map((items: any) => {
  //         return items;
  //       });
  //   }
  //   fillData(tabelFilter!);
  // };
  // const setChildValueLoanTemplate = (childValues: any) => {
  //   const selectedItem = valueLoanTemplateOptions.filter(
  //     (item: any) => item != childValues
  //   );
  //   const selectedItemValue = valueLoanTemplate.filter(
  //     (item: any) => item.id != childValues
  //   );
  //   setValueLoanTemplateOptions(selectedItem);
  //   setValueLoanTemplate(selectedItemValue);

  //   const tabelFilter = queryClient.getQueryData<FilterRegister>(
  //     TABLE_FILTER_APP
  //   );
  //   if (tabelFilter != undefined && tabelFilter != null) {
  //     tabelFilter!.loanTemplateIds = tabelFilter!.loanTemplateIds
  //       ?.filter((item: any) => item != childValues)
  //       .map((items: any) => {
  //         return items;
  //       });
  //     tabelFilter!.valueLoanTemplate = tabelFilter!.valueLoanTemplate
  //       ?.filter((item: any) => item.id != childValues)
  //       .map((items: any) => {
  //         return items;
  //       });
  //   }
  //   fillData(tabelFilter!);
  // };
  // const setChildValueCustomerFullName = (childValues: any) => {
  //   const selectedItem = "";
  //   setValueCustomerFullName(selectedItem);
  //   const tabelFilter = queryClient.getQueryData<FilterRegister>(
  //     TABLE_FILTER_APP
  //   );
  //   if (tabelFilter != undefined && tabelFilter != null)
  //     tabelFilter!.customerFullName = undefined;
  //   fillData(tabelFilter!);
  // };

  // const setChildValueCustomerNationalCode = (childValues: any) => {
  //   const selectedItem = "";
  //   setValueCustomerNationalCode(selectedItem);
  //   const tabelFilter = queryClient.getQueryData<FilterRegister>(
  //     TABLE_FILTER_APP
  //   );
  //   if (tabelFilter != undefined && tabelFilter != null)
  //     tabelFilter!.customerNationalCode = undefined;
  //   fillData(tabelFilter!);
  // };

  // const setChildValueCustomerMobileNumber = (childValues: any) => {
  //   const selectedItem = "";
  //   setValueCustomerMobileNumber(selectedItem);
  //   const tabelFilter = queryClient.getQueryData<FilterRegister>(
  //     TABLE_FILTER_APP
  //   );
  //   if (tabelFilter != undefined && tabelFilter != null)
  //     tabelFilter!.customerMobileNumber = undefined;
  //   fillData(tabelFilter!);
  // };

  // const setChildValueRequestDate = (childValues: any) => {
  //   const selectedItem = "";
  //   setValueRequestDate(selectedItem);
  //   setRequestDate(undefined);
  //   const tabelFilter = queryClient.getQueryData<FilterRegister>(
  //     TABLE_FILTER_APP
  //   );
  //   if (tabelFilter != undefined && tabelFilter != null) {
  //     tabelFilter!.requestDateFrom = undefined;
  //     tabelFilter!.requestDateTo = undefined;
  //     tabelFilter!.requestDatePersian = "";
  //     tabelFilter!.requestDateArray = [];
  //   }

  //   fillData(tabelFilter!);
  // };

  // const setChildValueStatusDate = (childValues: any) => {
  //   const selectedItem = "";
  //   setValueStatusDate(selectedItem);
  //   setStatusDate(undefined);

  //   const tabelFilter = queryClient.getQueryData<FilterRegister>(
  //     TABLE_FILTER_APP
  //   );
  //   if (tabelFilter != undefined && tabelFilter != null) {
  //     tabelFilter!.statusDateFrom = undefined;
  //     tabelFilter!.statusDateTo = undefined;
  //     tabelFilter!.statusDateArray = [];
  //     tabelFilter!.statusDatePersian = "";
  //   }
  //   fillData(tabelFilter!);
  // };

  // const generateFilter = (
  //   filterData: FilterRegister
  // ): SearchLoanRegisterRequestsRequest => {
  //   let request = new SearchLoanRegisterRequestsRequest();
  //   request.paginationInfo = currentPaginationInfo;
  //   request.filter = filterData;
  //   if (request.filter != undefined)
  //     request.filter.cartableTitle = "درخواست های ثبت نام";

  //   //checked
  //   // request.filter.state = stateCartable.stateCartable;
  //   return request;
  // };

  // const fillData = (filterData: FilterRegister) => {
  //   let filter = generateFilter(filterData);
  //   SearchLoanRegisterRequestsMutation(filter);
  //   setValueFilterData(filter?.filter);
  // };

  // const changePageNumber = (newPageNumber: number) => {
  //   const tabelFilter = queryClient.getQueryData<FilterRegister>(
  //     TABLE_FILTER_APP
  //   );
  //   fillData(tabelFilter!);
  //   currentPaginationInfo.pageNumber = newPageNumber;
  //   setCurrentPaginationInfo(currentPaginationInfo);
  //   // fillData(new Filter())
  // };

  // const handleChangePage = (event: unknown, newPage: number) => {
  //   changePageNumber(newPage + 1);
  // };
  // const handleChangePagination = (event: any, value: any) => {
  //   changePageNumber(value);
  //   handleSelectRow(undefined);
  // };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    alert("handleChangeRowsPerPage");
    // setRowsPerPage(+event.target.value);
    // setPage(0);
  };

  // const handleChangeMultiselect = (
  //   event: SelectChangeEvent<typeof loanRequestOptions>
  // ) => {
  //   const {
  //     target: { value },
  //   } = event;
  // };
  // const disposeListener = history.listen((navData) => {
  //   if (
  //     navData.pathname === "/Search/CustomerSearch" &&
  //     history.location.state !== undefined &&
  //     history.location.state.pageNumber!
  //   ) {
  //     currentPaginationInfo.pageNumber = history.location.state.pageNumber;
  //     setCurrentPaginationInfo(currentPaginationInfo);
  //   }
  // });
  // const handleDetail = (referenceKey: string, rowIndex: number) => {
  //   window.sessionStorage.setItem("idFind", referenceKey);
  //   handleSelectRow(rowIndex);
  //   queryClient.setQueryData(SUPPLIER_ATTACHMENTS_UPLOADED, null);
  //   //history.push(`/loan-detail/${referenceKey}`);
  //   history.push({
  //     // pathname: `/Search/CustomerSearch1/request-find-detail`,
  //     pathname: `/Search/${activePage}1/request-find-detail`,
  //     state: {
  //       id: referenceKey,
  //       from: "",
  //       pageNumber: currentPaginationInfo.pageNumber!,
  //       clickOnBack: false,
  //     },
  //   });
  // };
  // const handleSelectRow = (rowIndex: any) => {
  //   const cachPageNumber = queryClient.getQueryData(
  //     TABLE_FILTER_APP_ROWNumber
  //   ) as FilterFinder;
  //   const filter = new FilterFinder();
  //   filter.rowNumber = rowIndex;
  //   setSelectedRow(rowIndex);
  //   queryClient.setQueryData(TABLE_FILTER_APP_ROWNumber, filter);
  // };
  function handelCollapse() {
    setExpanded(!isExpanded);
  }
  function changeMultiSelectChip(e: any) {
    setValueMultiSelect(e);
  }
  function changeValueSupplierSettlementStatus(e: any) {
    setValueSupplierSettlementStatus(e);
  }
  function changeValueLoanRequestSources(e: any) {
    setValueLoanRequestSources(e);
  }
  function changeValueLoanTemplateOptions(e: any, value: any) {
    setValueLoanTemplateOptions(e);
    setValueLoanTemplate(value);
  }

  function changeValueCustomerFullName(e: any) {
    setValueCustomerFullName(e.currentTarget.value);
  }
  function changeValueCustomerNationalCode(e: any) {
    setValueCustomerNationalCode(e.currentTarget.value);
  }
  function changeValueCustomerMobileNumber(e: any) {
    setValueCustomerMobileNumber(e.currentTarget.value);
  }
  function changeValueRequestDate(e: any) {
    setRequestDate(e);
    setValueRequestDate(e.toString());
  }
  function changeValueStatusDate(e: any) {
    setStatusDate(e);
    setValueStatusDate(e.toString());
  }
  // function deleteChip() {
  //   setValueMultiSelect([]);
  //   setValueLoanTemplateOptions([]);
  //   setValueLoanTemplate([]);
  //   setValueCustomerFullName("");
  //   setValueCustomerNationalCode("");
  //   setValueCustomerMobileNumber("");
  //   setValueRequestDate("");
  //   setValueStatusDate("");
  //   setStatusDate([]);
  //   setRequestDate([]);

  //   queryClient.setQueryData(TABLE_FILTER_APP, null);
  //   fillData(queryClient.getQueryData(TABLE_FILTER_APP)!);
  //   currentPaginationInfo.pageNumber = 1;
  //   setCurrentPaginationInfo(currentPaginationInfo);
  // }
  const filter = new FilterRegister();
  filter.loanRequestStatus = [];
  filter.loanTemplateIds = [];
  // const lessFilter = (
  //   <span style={{ textAlign: "center" }}>
  //     <ArrowDropUpIcon style={{ color: "#1D4A87" }} />
  //     فیلترهای کمتر{" "}
  //   </span>
  // );
  // const extraFilter = (
  //   <span style={{ textAlign: "center" }}>
  //     <ArrowDropDownIcon style={{ color: "#1D4A87" }} />
  //     فیلترهای بیشتر
  //   </span>
  // );

  const handleClick = () => {
    console.info("You clicked the Chip.");
  };

  const handleDelete = () => {
    console.info("You clicked the delete icon.");
  };
  const [isShow, setIsShow] = useState(true);
  let handelFilter = () => {
    setIsShow(!isShow);
  };
  let exportExcel = () => {
    // ExportLoanRegisterRequestsMutation.mutate(
    //   valueFilterData ? valueFilterData! : new FilterRegister()
    // );
  };
  const handleDetail = (key: string) => {
    window.sessionStorage.setItem("key-tablePaymentRequestInfo", key);
    history.push({
      pathname: `/Payment/paymentRequestInfo`,
      state: {
        id: key,
        from: "SettlementRequestsBySupplier",
        pageNumber: 1,
        clickOnBack: false,
      },
    });
  };

  return (
    <>
      {/* <Button onClick={handelFilter}> */}
      {/* <Tooltip title="فیلتر " arrow>
        <img
          onClick={handelFilter}
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src="images/filter.png"
        />
      </Tooltip>

      <span style={{ margin: "2vh", color: "#CFD8DC" }}>|</span> */}
      {/* <Tooltip title="خروجی اکسل" arrow>
        <img
          onClick={exportExcel}
          className="cursorPointer"
          style={{ width: "24px", height: "24px", marginBottom: ".5vh" }}
          src="images/ExportXLS.svg"
        />
      </Tooltip> */}
      {/* </Button> */}
      {isShow ? (
        <Box sx={{ flexGrow: 1 }}>
          <Formik
            initialValues={filter}
            onSubmit={(values) => {
              // if (
              //   requestDate != null &&
              //   (requestDate[0] != undefined || requestDate[1] != undefined)
              // ) {
              //   values.requestDateFrom = convertToLocalDateTime(
              //     Number(requestDate[0])
              //   );
              //   if (requestDate?.length > 1) {
              //     values.requestDateTo = convertToLocalDateTime(
              //       Number(requestDate[1])
              //     );
              //   } else {
              //     values.requestDateTo = convertToLocalDateTime(
              //       Number(requestDate[0])
              //     );
              //   }
              // } else {
              //   values.requestDateTo = undefined;
              //   values.requestDateFrom = undefined;
              // }
              // if (
              //   statusDate != null &&
              //   (statusDate[0] != undefined || statusDate[1] != undefined)
              // ) {
              //   values.statusDateFrom = convertToLocalDateTime(
              //     Number(statusDate[0])
              //   );
              //   if (statusDate?.length > 1) {
              //     values.statusDateTo = convertToLocalDateTime(
              //       Number(statusDate[1])
              //     );
              //   } else {
              //     values.statusDateTo = convertToLocalDateTime(
              //       Number(statusDate[0])
              //     );
              //   }
              // } else {
              //   values.statusDateFrom = undefined;
              //   values.statusDateTo = undefined;
              // }
              //
            }}
          >
            {({ handleSubmit, handleChange, values }) => (
              <form onSubmit={handleSubmit}>
                <div className="row">
                  {/* <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      // className="shadowTextField"
                      helperText={""}
                      placeHolder={"نام و نام خانوادگی متقاضی"}
                      label={"نام و نام خانوادگی متقاضی"}
                      required={false}
                      value={valueCustomerFullName}
                      onChange={changeValueCustomerFullName}
                      name="customerFullName"
                      id="customerFullName"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      // className="shadowTextField"
                      helperText={""}
                      placeHolder={"کد ملی"}
                      label={"کد ملی "}
                      required={false}
                      value={valueCustomerNationalCode}
                      onChange={changeValueCustomerNationalCode}
                      name="customerNationalCode"
                      id="customerNationalCode"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <MaterialTextFieldComponent
                      // className="shadowTextField"
                      helperText={""}
                      placeHolder={"شماره همراه"}
                      label={"شماره همراه"}
                      required={false}
                      value={valueCustomerMobileNumber}
                      onChange={changeValueCustomerMobileNumber}
                      name="customerMobileNumber"
                      id="customerMobileNumber"
                    />
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div dir="rtl">
                          <MultiSelectChip
                            id="loanRequestStatus"
                            name="loanRequestStatus"
                            value={valueMultiSelect}
                            label="وضعیت درخواست"
                            options={loanRequestStatus}
                            onChange={changeMultiSelectChip}
                            changeMultiSelect={changeMultiSelectChip}
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <FormControl fullWidth className="shadowDatepicker">
                      <DatePickerComponents
                        valueArray={requestDate}
                        label={"تاریخ درخواست"}
                        // onChange={(newValue: any) => {
                        //   setRequestDateFrom(newValue);
                        // }}
                        onChange={changeValueRequestDate}
                        range={true}
                      />
                    </FormControl>
                  </div>
                  <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <FormControl fullWidth className="shadowDatepicker">
                      <DatePickerComponents
                        valueArray={statusDate}
                        label={"تاریخ آخرین وضعیت "}
                        // onChange={(newValue: any) => {
                        //   setStatusDateFrom(newValue);
                        // }}
                        onChange={changeValueStatusDate}
                        range={true}
                      />
                    </FormControl>
                  </div> */}
                  {/* <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12"
                    style={{ marginTop: "1vh" }}
                  >
                    <CacheProvider value={cacheRtl}>
                      <ThemeProvider theme={theme}>
                        <div dir="rtl">
                          <Autocomplate
                            id="loanTemplateIds"
                            name="loanTemplateIds"
                            value={valueLoanTemplateOptions}
                            label="طرح تسهیلات"
                            options={loanTemplateOptions}
                            onChange={changeValueLoanTemplateOptions}
                            changeMultiSelect={changeValueLoanTemplateOptions}
                            responseValue={valueLoanTemplate}
                          />
                        </div>
                      </ThemeProvider>
                    </CacheProvider>
                  </div> */}
                  {/* <div
                    className="col-lg-2 col-md-4 col-sm-6 col-xs-12 col-12 butFilter"
                    style={{ marginTop: "1vh" }}
                  >
                    <Button
                      fullWidth
                      variant="contained"
                      type="submit"
                      className="btnForm SuccessDefault  "
                    >
                      اعمال فیلتر
                    </Button>
                  </div> */}
                </div>
                {/* {valueMultiSelect?.length ||
                  valueSupplierSettlementStatus?.length ||
                  valueLoanTemplateOptions?.length ||
                  valueLoanRequestSources?.length ||
                  valueSupplierUserOptions?.length ||
                  valueCustomerFullName ||
                  valueCustomerNationalCode ||
                  valueCustomerMobileNumber ||
                  valueRequestDate ||
                  valueStatusDate ? (
                  <div className="row tableCMP">
                    <Button
                      onClick={deleteChip}
                      style={{
                        justifyContent: "right",
                        minWidth: "25px",
                        marginRight: "-1vh",
                      }}
                    >
                      <img
                        style={{ height: "24px", width: "24px" }}
                        src="images/RemoveAllFilters.svg"
                      />
                    </Button>
                    <ChipCmp
                      item={valueMultiSelect}
                      enamValue={loanRequestStatus}
                      index={valueMultiSelect?.length}
                      setChildValue={setChildValueStat}
                    />
                    <ChipCmp
                      item={valueLoanTemplateOptions}
                      enamValue={loanTemplateOptions}
                      index={valueLoanTemplateOptions?.length}
                      setChildValue={setChildValueLoanTemplate}
                    />
                    <ChipCmp
                      item={valueCustomerFullName}
                      enamValue={valueCustomerFullName}
                      index={valueCustomerFullName?.length}
                      setChildValue={setChildValueCustomerFullName}
                    />
                    <ChipCmp
                      item={valueCustomerNationalCode}
                      enamValue={valueCustomerNationalCode}
                      index={valueCustomerNationalCode?.length}
                      setChildValue={setChildValueCustomerNationalCode}
                    />
                    <ChipCmp
                      item={valueCustomerMobileNumber}
                      enamValue={valueCustomerMobileNumber}
                      index={valueCustomerMobileNumber?.length}
                      setChildValue={setChildValueCustomerMobileNumber}
                    />
                    <ChipCmp
                      item={valueRequestDate}
                      enamValue={valueRequestDate}
                      index={valueRequestDate?.length}
                      setChildValue={setChildValueRequestDate}
                    />
                    <ChipCmp
                      item={valueStatusDate}
                      enamValue={valueStatusDate}
                      index={valueStatusDate?.length}
                      setChildValue={setChildValueStatusDate}
                    />
                  </div>
                ) : (
                  ""
                )} */}
              </form>
            )}
          </Formik>
        </Box>
      ) : (
        ""
      )}
      <br />
      {
        <>
          <div
            className="cardTableBorder"
            style={{
              height: "370px",
              maxHeight: "334px",
              marginBottom: "35px",
            }}
          >
            <TableContainer
              style={{
                background: "#fff",
                height: "310px",
                maxHeight: "334px",
              }}
              className="boxScroll"
            >
              <Table
                stickyHeader
                aria-label="sticky table"
                style={{ borderCollapse: "collapse" }}
              >
                <TableHead
                  className="rowTHead"
                  style={{ paddingBottom: "10px" }}
                >
                  <TableRow
                    classes={{ root: classes.select }}
                    className={`${classes} borderRight borderLeft cursorPointer`}
                    // selected={selectedRow === 0}
                  >
                    <TableCell
                      className="rowTHead colorTitle textFont12 fontWeight stickyColO"
                      align="right"
                      style={{ width: "10vh", minWidth: "10vh" }}
                    >
                      <Tooltip arrow title="انتخاب همه">
                        <Button
                          className=" colorTitle textFont12 fontWeight "
                          onClick={() => {
                            addAllData();
                          }}
                          style={{
                            textAlign: "center",
                            fontWeight: "bolder",
                          }}
                        >
                          <PlaylistAddIcon
                            style={{ background: "transparent" }}
                          />
                        </Button>
                      </Tooltip>
                    </TableCell>
                    {columns.map((column) => (
                      <TableCell
                        className="rowTHead colorTitle textFont12 fontWeight noWrap"
                        key={column.id}
                        align="right"
                      >
                        {column.label}
                      </TableCell>
                    ))}
                    {/* <TableCell
                      className="rowTHead colorTitle stickyColO "
                      align="right"
                    >
                      <MoreHorizIcon
                        scale="scale(1.8) "
                        style={{ color: "#1D4A87" }}
                      />
                    </TableCell> */}
                  </TableRow>
                </TableHead>
                <div style={{ width: "100%", height: "10px" }}></div>
                <TableBody>
                  {data
                    ? data.map((row, rowIndex) => {
                        return (
                          <TableRow
                            classes={{ root: classes.select }}
                            className={`${
                              rowIndex % 2 == 0 ? "rowTBodyE  " : "rowTBodyO "
                            } ${classes} borderRight borderLeft  noWrap cursorPointer`}
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            // key={row.loanRequestId}
                            // selected={selectedRow === rowIndex}
                          >
                            {/* <TableCell
                            className="textFont12"
                            style={{ width: "10vh", minWidth: "10vh" }}
                          >
                            {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                              (currentPaginationInfo.pageSize! ?? 0) +
                              rowIndex +
                              1}
                          </TableCell> */}
                            <TableCell
                              className={`colorTitle textFont12 fontWeight backgroundColorTransparet ${
                                rowIndex % 2 === 0
                                  ? "stickyColO  "
                                  : "stickyColE"
                              }`}
                              align="right"
                              style={{
                                width: "10vh",
                                minWidth: "10vh",
                                textAlign: "center",
                                fontWeight: "bolder",
                              }}
                            >
                              <Button
                                className=" colorTitle textFont12 fontWeight "
                                onClick={() => {
                                  addInPlayList(row);
                                }}
                                style={{
                                  textAlign: "center",
                                  fontWeight: "bolder",
                                }}
                              >
                                <PlaylistAddIcon
                                  style={{ background: "transparent" }}
                                />
                              </Button>
                            </TableCell>
                            {columns.map((column) => {
                              const value =
                                row[
                                  column.id as keyof GetSettlementRequestsBySupplierResponse
                                ];
                              return (
                                <TableCell
                                  className="textFont12"
                                  key={column.id}
                                  align="right"
                                  onClick={() => handleDetail(row?.key!)}
                                >
                                  {column.format && column.hasFormat
                                    ? column.format(value)
                                    : value?.toString()}
                                </TableCell>
                              );
                            })}
                            {/* <TableCell
                            className={
                              rowIndex % 2 == 0
                                ? " stickyColO   "
                                : " stickyColE  "
                            }
                          >
                            <MoreHorizIcon
                              scale="scale(1.8) "
                              className="cursorPointer"
                              style={{ color: "#1D4A87" }}
                              onClick={() =>
                                handleDetail(row?.key!)
                              }
                            />
                          </TableCell> */}
                          </TableRow>
                        );
                      })
                    : null}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          <span
            style={{
              color: "#1D4A87",
              fontSize: "16px",
              fontWeight: "bold",
              marginRight: "15px",
            }}
          >
            <span
              style={{ color: "#1D4A87", fontSize: "16px", fontWeight: "bold" }}
            >
              لیست منتخب تسویه &nbsp;
              <span
                style={{
                  color: "#1D4A87",
                  fontSize: "14px",
                  fontWeight: "normal",
                }}
              >
                (
                {playlistData.length !== undefined &&
                playlistData.length != null
                  ? playlistData.length
                  : 0}{" "}
                مورد){" "}
              </span>
            </span>
          </span>
          <div
            className="cardTableBorder"
            style={{
              height: "360px",
              maxHeight: "330px",
              marginBottom: "20px",
              marginTop: "11px",
            }}
          >
            <TableContainer
              style={{
                background: "#fff",
                height: "305px",
                maxHeight: "330px",
              }}
              // className="boxScroll"
            >
              <Table
                stickyHeader
                aria-label="sticky table"
                style={{ borderCollapse: "collapse" }}
              >
                <TableHead
                  className="rowTHead"
                  style={{ paddingBottom: "10px" }}
                >
                  <TableRow
                    classes={{ root: classes.select }}
                    className={`${classes} borderRight borderLeft cursorPointer`}
                    // selected={selectedRow === 0}
                  >
                    <TableCell
                      className="rowTHead colorTitle textFont12 fontWeight stickyColO"
                      align="right"
                      style={{ width: "10vh", minWidth: "10vh" }}
                    >
                      <Tooltip arrow title="لغو همه">
                        <Button
                          className=" colorTitle textFont12 fontWeight"
                          onClick={() => {
                            removeAllData();
                          }}
                          style={{
                            textAlign: "center",
                            fontWeight: "bolder",
                          }}
                        >
                          <img
                            onClick={exportExcel}
                            className="cursorPointer"
                            style={{
                              width: "17px",
                              height: "17px",
                              marginBottom: ".5vh",
                              background: "transparent",
                            }}
                            src="images/RemoveFromPlaylist.svg"
                          />
                        </Button>
                      </Tooltip>
                    </TableCell>
                    {columns.map((column) => (
                      <TableCell
                        className="rowTHead colorTitle textFont12 fontWeight noWrap"
                        key={column.id}
                        align="right"
                      >
                        {column.label}
                      </TableCell>
                    ))}
                    {/* <TableCell
                      className="rowTHead colorTitle stickyColO "
                      align="right"
                    >
                      <MoreHorizIcon
                        scale="scale(1.8) "
                        style={{ color: "#1D4A87" }}
                      />
                    </TableCell> */}
                  </TableRow>
                </TableHead>
                <div style={{ width: "100%", height: "10px" }}></div>
                <TableBody>
                  {playlistData
                    ? playlistData.map((row, rowIndex) => {
                        return (
                          <TableRow
                            classes={{ root: classes.select }}
                            className={`${
                              rowIndex % 2 == 0 ? "rowTBodyE  " : "rowTBodyO "
                            } ${classes} borderRight borderLeft  noWrap cursorPointer`}
                            hover
                            role="checkbox"
                            tabIndex={-1}
                            // key={row.loanRequestId}
                            // selected={selectedRow === rowIndex}
                          >
                            {/* <TableCell
                            className="textFont12"
                            style={{ width: "10vh", minWidth: "10vh" }}
                          >
                            {((currentPaginationInfo.pageNumber ?? 0) - 1) *
                              (currentPaginationInfo.pageSize! ?? 0) +
                              rowIndex +
                              1}
                          </TableCell> */}
                            <TableCell
                              className={`colorTitle textFont12 fontWeight backgroundColorTransparet ${
                                rowIndex % 2 === 0
                                  ? "stickyColO  "
                                  : "stickyColE"
                              }`}
                              align="right"
                              style={{
                                width: "10vh",
                                minWidth: "10vh",
                                textAlign: "center",
                                fontWeight: "bolder",
                              }}
                            >
                              <Button
                                className=" colorTitle textFont12 fontWeight"
                                onClick={() => {
                                  removeFromPlayList(row);
                                }}
                                style={{
                                  textAlign: "center",
                                  fontWeight: "bolder",
                                }}
                              >
                                <img
                                  onClick={exportExcel}
                                  className="cursorPointer"
                                  style={{
                                    width: "17px",
                                    height: "17px",
                                    marginBottom: ".5vh",
                                    background: "transparent",
                                  }}
                                  src="images/RemoveFromPlaylist.svg"
                                />
                              </Button>
                            </TableCell>
                            {columns.map((column) => {
                              const value =
                                row[
                                  column.id as keyof GetSettlementRequestsBySupplierResponse
                                ];
                              return (
                                <TableCell
                                  className="textFont12"
                                  key={column.id}
                                  align="right"
                                  onClick={() => handleDetail(row?.key!)}
                                >
                                  {column.format && column.hasFormat
                                    ? column.format(value)
                                    : value?.toString()}
                                </TableCell>
                              );
                            })}
                            {/* <TableCell
                            className={
                              rowIndex % 2 == 0
                                ? " stickyColO   "
                                : " stickyColE  "
                            }
                          >
                            <MoreHorizIcon
                              scale="scale(1.8) "
                              className="cursorPointer"
                              style={{ color: "#1D4A87" }}
                              onClick={() =>
                                handleDetail(row?.key!)
                              }
                            />
                          </TableCell> */}
                          </TableRow>
                        );
                      })
                    : null}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          <div style={{ marginTop: "18px", paddingBottom: "30px" }}>
            <Grid
              container
              xs={12}
              spacing={1}
              columns={{ xs: 2, sm: 8, md: 12 }}
            >
              <Grid item xs={6} md={6} sm={1}></Grid>
              <Grid
                item
                xs={4}
                md={4}
                sm={9}
                style={{
                  direction: "rtl",
                  marginTop: "9px",
                  borderRadius: "5px",
                  backgroundColor: "#F9FAFC",
                  border: "1px solid #DAE0E4",
                }}
              >
                <Grid container xs={12}>
                  <Grid item xs={4} style={{ textAlign: "center" }}>
                    <span style={{ color: "#1D4A87" }}>جمع کل (ریال):</span>
                  </Grid>
                  <Grid item xs={8} style={{ textAlign: "end" }}>
                    <span style={{ color: "#1D4A87", fontWeight: "bold" }}>
                      {settlementAmount
                        ? settlementAmount!.toLocaleString()
                        : ""}
                    </span>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                xs={2}
                md={2}
                sm={1}
                style={{ right: "9px", position: "relative", textAlign: "end" }}
              >
                <Button
                  type="submit"
                  onClick={onClickSettlementType}
                  disabled={
                    supplierSettlementRequestKeys.length == 0 ? true : false
                  }
                  className={
                    supplierSettlementRequestKeys.length == 0
                      ? "btnForm disabledBtn  "
                      : "btnForm SuccessDefault "
                  }
                  style={{ width: "170px" }}
                >
                  تایید و ثبت درخواست
                </Button>
              </Grid>
            </Grid>
          </div>
          {/* <div>
            <div className="row"></div>
            <Grid container xs={12}>
              <Grid item xs={4}>
                <span
                  style={{ color: "#1D4A87", top: "1vh", position: "relative" }}
                >
                  تعداد کل :
                  <span style={{ color: "#01AF43" }}>{pageInfo.total}</span>{" "}
                  مورد
                </span>
              </Grid>
              <Grid item xs={4}>
                <Pagination
                  renderItem={(item) => (
                    <PaginationItem
                      components={{
                        previous: previusIcon,
                        next: nextIcon,
                      }}
                      {...item}
                    />
                  )}
                  // color="primary"
                  sx={{
                    display: "flex",
                    justifyContent: "center !important",
                    direction: "ltr",
                    margin: "5px",
                    button: {
                      color: "#25D1C9",
                      fontSize: "14px !important",
                      fontFamily: "iranSans",
                    },
                    //  button.sele
                  }}
                  count={
                    pageInfo ? Math.ceil(pageInfo.total / pageInfo.pageSize) : 0
                  }
                  onChange={handleChangePagination}
                  page={currentPaginationInfo.pageNumber}
                />
              </Grid>
              <Grid item xs={4}></Grid>
            </Grid>
          </div> */}
        </>
      }
      <ModalSettlementType
        openModel={openVerifyModal}
        setSendConfirmation={setSendConfirmation}
        setOpenVerifyModal={setOpenVerifyModal}
        supplierSettlementRequestKeys={supplierSettlementRequestKeys}
        settlementAmount={settlementAmount}
      />
    </>
  );
}
interface TableCmpPropsInterface {
  stateCartable: any;
  status: any;
}
const mapStateToProps = ({ stateCartable, status }: TableCmpPropsInterface) => {
  return {
    stateCartable,
    status,
  };
};

export default withRouter(
  connect(mapStateToProps)(SettlementRequestsBySupplier)
);
const onKeyDown = (e: any) => {
  e.preventDefault();
};
